import React from 'react';

const CellWithPairCurrency = ({number, currency1, currency2}) => {

    return (
        currency1 === currency2 ?  <div>-</div> : <div>{number} {currency1}\{currency2}</div>
    );
};

export default CellWithPairCurrency;